import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { getMoneyDisplay, getCurrencySignature, getShopCurrencyCode, syncMoneyDisplay } from '../utils/currency';

const BuilderMoney = ({ amount, sourceCurrencyCode = getShopCurrencyCode(), className = '' }) => {
    const moneyRef = useRef(null);
    const [, setCurrencySignature] = useState(() => getCurrencySignature(amount, sourceCurrencyCode));
    const display = getMoneyDisplay(amount, sourceCurrencyCode);

    useEffect(() => {
        if (typeof window === 'undefined') return undefined;

        const syncCurrency = () => {
            const nextSignature = getCurrencySignature(amount, sourceCurrencyCode);
            setCurrencySignature((currentSignature) =>
                currentSignature === nextSignature ? currentSignature : nextSignature
            );
        };

        syncCurrency();

        const intervalId = window.setInterval(syncCurrency, 500);
        window.addEventListener('focus', syncCurrency);
        document.addEventListener('visibilitychange', syncCurrency);

        return () => {
            window.clearInterval(intervalId);
            window.removeEventListener('focus', syncCurrency);
            document.removeEventListener('visibilitychange', syncCurrency);
        };
    }, [amount, sourceCurrencyCode]);

    useEffect(() => {
        if (typeof window === 'undefined') return undefined;

        const target = moneyRef.current;
        if (!target) return undefined;

        const evaluateDisplaySource = () => {
            syncMoneyDisplay(target, sourceCurrencyCode, display.allowCbb);
        };

        evaluateDisplaySource();

        const parentObserver = new MutationObserver(evaluateDisplaySource);
        parentObserver.observe(target.parentElement || target, {
            childList: true,
            subtree: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['style', 'class'],
        });

        const intervalId = window.setInterval(evaluateDisplaySource, 1200);

        return () => {
            parentObserver.disconnect();
            window.clearInterval(intervalId);
        };
    }, [amount, sourceCurrencyCode, display.html, display.allowCbb]);

    if (!display.html) {
        return null;
    }

    return (
        <span
            ref={moneyRef}
            className={`${className} notranslate`.trim()}
            data-cbb-disabled={display.allowCbb ? undefined : 'true'}
            dangerouslySetInnerHTML={{ __html: display.html }}
        />
    );
};

BuilderMoney.propTypes = {
    amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
    sourceCurrencyCode: PropTypes.string,
    className: PropTypes.string,
};

export default BuilderMoney;
